import React from 'react';
import { logger } from '@fiverr-private/obs';
import { I18n } from '@fiverr-private/i18n-react';
import { Container } from '@fiverr-private/layout_components';
import { Button } from '@fiverr-private/button';
import { reportSeeMoreEvent, Events } from '../../../utils/reports/seeMore';
import './styles.scss';

const LOAD_MORE = 'Load more';

const LoadMoreBtn = ({ fetchReviews, type, lastReviewDetails, onLoadMoreClick }) => {
    const handleFetchReviews = (e) => {
        e.preventDefault();

        fetchReviews({
            filterType: type,
            isFilter: false,
            lastReviewDetails,
        })
            .then((eventData) => {
                eventData && reportSeeMoreEvent(Events.seeMore, eventData);
                onLoadMoreClick && onLoadMoreClick(LOAD_MORE);
            })
            .catch((error) => {
                logger.error(error, {
                    func: 'fetchReviews',
                    component: 'LoadMoreBtn',
                });
            });
    };

    return (
        <Container marginTop="8">
            <Button variant="outline" onClick={handleFetchReviews}>
                <I18n k="reviews.general.show_more_reviews" />
            </Button>
        </Container>
    );
};

export default LoadMoreBtn;
